import {createSlice} from "@reduxjs/toolkit";
const initialAdministrativosState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  administrativoForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const administrativosSlice = createSlice({
  name: "administrativos",
  initialState: initialAdministrativosState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    // getAdministrativoById
    administrativoFetched: (state, action) => {
      state.listLoading = false;
      state.administrativoForEdit = action.payload.administrativoForEdit;
      state.error = null;
    },
    // findAdministrativos
    administrativosFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createAdministrativo
    administrativoCreated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities.push(action.payload.administrativo);
    },
    // updateAdministrativo
    administrativoUpdated: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.administrativo.id) {
          return action.payload.administrativo;
        }
        return entity;
      });
    },
    // deleteAdministrativo
    administrativoDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteAdministrativos
    administrativosDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    }
  }
});
